import React from 'react';
import Modal from './Modal';
import { ModalProps, ModalSize } from './Modal.types';
import { Button, ButtonType } from '@hills-design-system/components';
import CheckCircleIcon from '../icons/CheckCircleIcon';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';

export interface SuccessModalProps extends Omit<ModalProps, 'children' | 'title'> {
  /**
   * Success message to display
   */
  message: string;
  /**
   * Function to call when the "Back to reports" button is clicked
   */
  onBackClick: () => void;
  /**
   * Custom label for the back button
   */
  backButtonLabel?: string;
}

/**
 * Modal for displaying success messages after completing an action
 */
const SuccessModal: React.FC<SuccessModalProps> = ({
  message,
  isOpen,
  onClose,
  onBackClick,
  backButtonLabel,
  size = ModalSize.Medium,
  showCloseButton = true,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title=""
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      showCloseButton={showCloseButton}
      className={className}
    >
      <div className="flex flex-col items-center justify-center w-full pb-14">
        <div className="flex flex-col items-center gap-6 w-full">
          <CheckCircleIcon className="text-primary" width={56} height={56} />
          <div className="flex flex-col items-center gap-4">
            <h2 className="font-montserrat font-semibold text-[32px] leading-[1.125em] tracking-[-1.5%] text-[#20252E] text-center whitespace-pre-line">
              {message}
            </h2>
          </div>
        </div>
        <div className="mt-8">
          <Button
            label={backButtonLabel ?? t(TranslationKeyEnum.BackToReports)}
            type={ButtonType.Primary}
            onClick={onBackClick}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;
